import React from 'react'
import Box from '@mui/material/Box'
import Switch from '@mui/material/Switch'
import Typography from '@mui/material/Typography'
import { makeStyles } from '@mui/styles'
import classnames from 'classnames'

interface DashboardThemeToggleProps {
  checked: boolean
  onChange?: () => void
  tone?: 'light' | 'dark'
  variant?: 'new' | 'legacy'
}

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  labelLight: {
    color: 'rgba(255,255,255,0.7)',
    fontSize: 13,
    fontWeight: 600,
  },
  labelLightActive: {
    color: '#fff',
  },
  labelDark: {
    color: '#6B7280',
    fontSize: 13,
    fontWeight: 600,
  },
  labelDarkActive: {
    color: '#111827',
  },
  switchRoot: {
    width: 64,
    height: 36,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 4,
      '&.Mui-checked': {
        transform: 'translateX(28px)',
      },
    },
    '& .MuiSwitch-thumb': {
      width: 28,
      height: 28,
      boxShadow: '0 3px 8px rgba(15, 23, 42, 0.2)',
    },
    '& .MuiSwitch-track': {
      borderRadius: 18,
      opacity: 1,
      backgroundColor: '#E5E7EB',
    },
  },
  switchNew: {
    '& .MuiSwitch-switchBase': {
      color: '#F8FAFC',
      '&.Mui-checked': {
        color: '#fff',
        '& + .MuiSwitch-track': {
          background: 'linear-gradient(135deg, #22C55E 0%, #16A34A 100%)',
        },
      },
      '& + .MuiSwitch-track': {
        background: 'linear-gradient(135deg, #FDE68A 0%, #F59E0B 100%)',
      },
    },
    '& .MuiSwitch-thumb': {
      background: '#FFF7E6',
    },
  },
  switchLegacy: {
    '& .MuiSwitch-switchBase': {
      color: '#F8FAFC',
      '&.Mui-checked': {
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: '#4A3D9E',
        },
      },
      '& + .MuiSwitch-track': {
        backgroundColor: '#CBD5E1',
      },
    },
    '& .MuiSwitch-thumb': {
      background: '#FFFFFF',
    },
  },
}))

const DashboardThemeToggle: React.FC<DashboardThemeToggleProps> = ({ checked, onChange, tone = 'dark', variant }) => {
  const classes = useStyles()
  const labelClass = tone === 'light' ? classes.labelLight : classes.labelDark
  const activeClass = tone === 'light' ? classes.labelLightActive : classes.labelDarkActive
  const appliedVariant = variant || (tone === 'light' ? 'new' : 'legacy')

  const handleChange = () => {
    if (onChange) {
      onChange()
    }
  }

  return (
    <Box className={classes.root}>
      <Typography className={classnames(labelClass, !checked && activeClass)}>Legacy</Typography>
      <Switch
        checked={checked}
        onChange={handleChange}
        className={classnames(classes.switchRoot, appliedVariant === 'new' ? classes.switchNew : classes.switchLegacy)}
      />
      <Typography className={classnames(labelClass, checked && activeClass)}>One Click</Typography>
    </Box>
  )
}

export default DashboardThemeToggle
